// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1iSYj","inner":"Form_inner__2TubY","range":"Form_range__phxZQ","name":"Form_name__cZHBj","actions":"Form_actions__MPSit"};